import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';
import paginationFactory, {PaginationProvider,} from "react-bootstrap-table2-paginator";
import {headerSortingClasses, NoRecordsFoundMessage, PleaseWaitMessage, sortCaret} from "../../../_metronic/_helpers";
import * as uiHelpers from "./BasketsUIHelpers";
import {Pagination} from "../../../_metronic/_partials/controls";
import {useHistory} from "react-router-dom";
import moment from "jalali-moment";

export default function BasketsTable({
                                         baskets,
                                         data,
                                         handlePageChange,
                                         activePage
                                     }) {

    const {SearchBar} = Search;
    const history = useHistory();

    const handleEdit = (id) => {
        history.push(`/customer/baskets/${id}`);
    };

    // Table columns
    const columns = [
        {
            dataField: "priority",
            text: "شماره",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "id",
            text: "شناسه سبد",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "user_id",
            text: "شناسه کاربر",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "totalAmount",
            text: "قیمت",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "orderQuantity",
            text: "تعداد سفارش",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "status.name",
            text: "وضعیت",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "created_at",
            text: "تاریخ ایجاد",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: (date) => {
                const createdDate = moment(date, 'YYYY-M-D HH:mm:ss').format('jYYYY/jMM/jDD');
                return <>{createdDate}</>;
            },
        },
        // {
        //     dataField: "action",
        //     text: "عملیات",
        //     formatter: columnFormatters.ActionsColumnFormatter,
        //     formatExtraData: {
        //         openEditPage: handleEdit,
        //         dealerDeleteClick: productContext.handleDelete
        //     },
        //     classes: "text-right pr-0",
        //     headerClasses: "text-right pr-3",
        //     style: {
        //         minWidth: "100px",
        //     },
        // },
    ];

    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: baskets.length,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: 15,
        page: +activePage
    };

    return (
        <>
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({paginationProps, paginationTableProps}) => {
                    return (
                        <Pagination
                            isLoading={false}
                            paginationProps={paginationProps}
                            handlePageChange={handlePageChange}
                            page={activePage}
                        >
                            <ToolkitProvider
                                keyField="id"
                                data={baskets}
                                columns={columns}
                                search
                            >
                                {
                                    props => (
                                        <div>
                                            <SearchBar {...props.searchProps} />
                                            <hr/>
                                            <BootstrapTable
                                                wrapperClasses="table-responsive"
                                                bordered={false}
                                                classes="table table-head-custom table-vertical-center overflow-hidden"
                                                bootstrap4
                                                defaultSorted={uiHelpers.defaultSorted}
                                                {...paginationTableProps}
                                                {...props.baseProps}
                                            >
                                                <PleaseWaitMessage entities={baskets}/>
                                                <NoRecordsFoundMessage entities={baskets}/>
                                            </BootstrapTable>
                                        </div>
                                    )
                                }
                            </ToolkitProvider>
                        </Pagination>
                    );
                }}
            </PaginationProvider>
        </>
    )
}